module.exports = require("@fortawesome/free-solid-svg-icons/faAngleDown");